import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classes from "./ParentalGate.module.scss";

const ParentalGate = ({ isOpen, onSuccess, onClose }) => {
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [answer, setAnswer] = useState("");
  const [error, setError] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setNum1(Math.floor(Math.random() * 50) + 20);
      setNum2(Math.floor(Math.random() * 50) + 20);
      setAnswer("");
      setError(false);
    }
  }, [isOpen]);

  const handleConfirm = () => {
    if (parseInt(answer, 10) === num1 + num2) {
      onSuccess();
      onClose();
    } else {
      setError(true);
      setAnswer("");
    }
  };

  if (!isOpen) return null;

  return (
    <div className={classes.overlay}>
      <div className={classes.modal} dir="rtl">
        <h3 className={classes.title}>אישור הורים</h3>
        <p className={classes.description}>
          לפני שנעביר אותך לדף המבוקש, אנא בקש ממבוגר לענות על השאלה הבאה:
        </p>
        <div className={classes.question}>
          {num1} + {num2} = ?
        </div>
        <input
          className={classes.input}
          type="number"
          value={answer}
          onChange={(e) => {
            setAnswer(e.target.value);
            setError(false);
          }}
          onKeyDown={(e) => e.key === "Enter" && handleConfirm()}
          placeholder="הכנס תשובה"
          autoFocus
        />
        {error && <p className={classes.error}>תשובה שגויה. אנא נסה שוב.</p>}
        <div className={classes.buttons}>
          <button className={classes.confirm} onClick={handleConfirm}>
            אישור
          </button>
          <button className={classes.cancel} onClick={onClose}>
            ביטול
          </button>
        </div>
      </div>
    </div>
  );
};

ParentalGate.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default ParentalGate;
